module.exports = __webpack_public_path__ + "img/program.caa39fe3.svg";